import React from 'react';

export default class Ad extends React.Component {
    componentDidMount() {
        if (!window.isAdsEnabled()) return;
        (window.adsbygoogle = window.adsbygoogle || []).push({});
    }

    render() {
        const type = this.props.type;
        return (
            <ins className="adsbygoogle"
                style={{ display: 'block' }}
                data-ad-client="ca-pub-5591173267528583"
                data-ad-slot={type.slot}
                data-ad-format={type.format}
                {...(type != AdType.MULTIPLEX && { 'data-full-width-responsive': 'true' })}></ins>
        );
    }
}

export class AdType {
    static RESPONSIVE = new AdType('4921098465', 'auto');
    static RESPONSIVE_2 = new AdType('6833748104', 'auto');
    static MULTIPLEX = new AdType('2045547824', 'autorelaxed');

    constructor(slot, format) {
        this.slot = slot;
        this.format = format;
    }
}